import { useEffect, useRef, useState } from 'react'

export const useIsVisibleElement = (reloadEffect = false) => {
  const element = useRef<HTMLDivElement>(null)
  const [elementVisible, setElementVisible] = useState(false)

  useEffect(() => {
    if (!element.current) return

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !elementVisible) {
        setElementVisible(true)
      } else if (reloadEffect && !entry.isIntersecting && elementVisible) {
        setElementVisible(false)
      }
    })

    observer.observe(element.current)
    // eslint-disable-next-line consistent-return
    return () => observer.disconnect()
  }, [elementVisible, reloadEffect])

  return { element, elementVisible }
}
